module.exports = __webpack_public_path__ + "img/heart.03ec6aa9.png";